import { SideNavContext } from 'context/sideNavContext';
import React, { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { AuthContext } from 'context/authContext';
import { useContextHook } from 'use-context-hook';
import { LangConverter } from 'helpers/common';
import {
  Li,
  StyledLink,
  Title,
  StyledSubMenu,
  SubMenuItem,
  SubMenuLink,
  SubMenuTitle,
  ArrowHolder,
} from './SideNav.styles';

function SubMenu({ item, isLoading }) {
  const { toggleSideNav } = useContextHook(SideNavContext, {
    toggleSideNav: 1,
  });
  const [subnav, setSubnav] = useState(false);
  const showSubnav = () => setSubnav(!subnav);
  const { allowedPages, lang } = useContextHook(AuthContext, {
    allowedPages: 1,
    lang: 1,
  });
  return (
    item.file !== 'profile' && (
      <Li css={isLoading && 'text-align: center;'}>
        {isLoading ? (
          <Skeleton circle height={40} width={40} css="margin: 0 auto;" />
        ) : (
          <StyledLink
            to={item.hideSelf ? `/admin/${item.file}/${item?.subNav[0]?.file}` : `/admin/${item.file}`}
            onClick={() => {
              showSubnav();
              toggleSideNav();
            }}>
            <i className="icon material-icons-outlined">{item.icon}</i>
            <Title>{LangConverter(item.name, lang.value)}</Title>
            {item.subNav && subnav ? (
              <ArrowHolder>
                <span className="material-icons-outlined">arrow_drop_up</span>
              </ArrowHolder>
            ) : item.subNav ? (
              <ArrowHolder>
                <span className="material-icons-outlined">arrow_drop_down</span>
              </ArrowHolder>
            ) : null}
          </StyledLink>
        )}
        {subnav && (
          <StyledSubMenu>
            {item?.subNav
              ?.filter(({ file }) => allowedPages.includes(file))
              .map((subNavItem, index) => (
                <SubMenuItem key={index}>
                  <SubMenuLink to={`/admin/${item?.file}/${subNavItem?.file}`}>
                    <i className="icon material-icons-outlined">{subNavItem.icon}</i>
                    <SubMenuTitle>{LangConverter(subNavItem.name, lang.value)}</SubMenuTitle>
                  </SubMenuLink>
                </SubMenuItem>
              ))}
          </StyledSubMenu>
        )}
      </Li>
    )
  );
}

export default SubMenu;
